import Pagination from "@/types/Pagination.interface"
import Person from "@/types/Person.interface"
import Group from "@/types/Group.interface"
import Message from "@/types/Message.interface"

interface State {
    groupsSearchList: Group[]
    personsSearchList: Person[]
    messagesSearchList: Message[]
    searchBarIndex: number
    searchBarList: Person[]
    searchBarListLastPage: number
    searchBarListNextPage: number
    searchBarListVisible: boolean
    searchBarText: string
    searchBarToggle: boolean
}

const defaults = () => {
    return {
        groupsSearchList: null,
        personsSearchList: null,
        messagesSearchList: null,
        searchBarIndex: -1,
        searchBarList: null,
        searchBarListLastPage: null,
        searchBarListNextPage: null,
        searchBarListVisible: true,
        searchBarText: '',
        searchBarToggle: true
    }
}

export default {
    state: defaults(),
    mutations: {
        groupsSearchListPush (state: State, page: Pagination) {
            if (!state.groupsSearchList || page.current_page === 1) state.groupsSearchList = []
            state.groupsSearchList = window.removeDuplicatesById(state.groupsSearchList, page.data)
            state.searchBarListLastPage = page.last_page
            state.searchBarListNextPage = page.current_page + 1
        },
        groupsSearchListSet (state: State, groups: Group[]): void {
            state.groupsSearchList = groups
        },

        personsSearchListPush (state: State, page: Pagination) {
            if (!state.personsSearchList || page.current_page === 1) state.personsSearchList = []
            state.personsSearchList = window.removeDuplicatesById(state.personsSearchList, page.data)
            state.searchBarListLastPage = page.last_page
            state.searchBarListNextPage = page.current_page + 1
        },
        personsSearchListSet (state: State, persons: Person[]): void {
            state.personsSearchList = persons
        },

        messagesSearchListPush (state: State, page: Pagination) {
            if (!state.messagesSearchList || page.current_page === 1) state.messagesSearchList = []
            state.messagesSearchList = window.removeDuplicatesById(state.messagesSearchList, page.data)
            state.searchBarListLastPage = page.last_page
            state.searchBarListNextPage = page.current_page + 1
        },
        messagesSearchListSet (state: State, messages: Message[]): void {
            state.messagesSearchList = messages
        },

        searchBarIndexSet (state: State, int: number): void {
            state.searchBarIndex = int
        },
        searchBarListSet (state: State, persons: Person[]): void {
            state.searchBarList = persons
        },
        searchBarListVisibleSet (state: State, bool: boolean): void {
            state.searchBarListVisible = bool
        },
        searchBarReset (state: State): void {
            Object.assign(state, defaults())
        },
        searchBarTextSet (state: State, str: string) {
            state.searchBarText = str
        },
        searchBarToggle (state: State, bool: boolean) {
            state.searchBarToggle = bool
        },
    },
    actions: {
        personsSearch ({ commit, getters }, params) {
            //  Assemble the API endpoint
            const url = `${getters.api}/persons/search?${window.toUrlParams(params)}`
            
            //  send the request
            return window.axios.get(url).then(response => {
                //  Only commit if we are paginating the list
                if (params.paginate) commit('personsSearchListPush', response.data)

                //  Return our pagination data
                return response.data
            }).catch(() => null)
        },
        groupsSearch ({ commit, getters }, params) {
            //  Assemble the API endpoint
            const url = `${getters.api}/groups/search?${window.toUrlParams(params)}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Only commit if we are paginating the list
                if (params.paginate) commit('groupsSearchListPush', response.data)

                //  Return our group
                return response.data
            }).catch(() => null)
        },
        messagesSearch ({ commit, getters }, params) {
            //  Assemble the API endpoint
            const url = `${getters.api}/messages/search?${window.toUrlParams(params)}`
            
            //  Send the request
            return window.axios.get(url).then(response => {
                //  Only commit if we are paginating the list
                if (params.paginate) commit('messagesSearchListPush', response.data)

                //  Return our group
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        groupsSearchList (state: State): Group[] {
            return state.groupsSearchList
        },
        personsSearchList (state: State): Person[] {
            return state.personsSearchList
        },
        messagesSearchList (state: State): Message[] {
            return state.messagesSearchList
        },
        searchBarIndex (state: State): number {
            return state.searchBarIndex
        },
        searchBarList (state: State): Person[] {
            return state.searchBarList
        },
        searchBarListLastPage (state: State): number {
            return state.searchBarListLastPage
        },
        searchBarListNextPage (state: State): number {
            return state.searchBarListNextPage
        },
        searchBarListVisible (state: State): boolean {
            return state.searchBarListVisible
        },
        searchBarText (state: State): string {
            return state.searchBarText
        },
        searchBarToggle (state: State): boolean {
            return state.searchBarToggle
        }
    }
}
